import { jwtDecode } from "jwt-decode";
import CryptoJS from 'crypto-js';

const getLoggedInUser = () => {
    // const decodedHeader = jwtDecode("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiJWVHFQMVJMT1pVV290cXZBb21wbW9kWlFjeG56Yjl5bFFPRHpVM2VQSXJEQzB5RTZTMjFLaDJ4enNNTi9PekxIOFVlL2sxdE9nVFhtVisyUzZCNVA3KzE5U0VoWm1CazByMytSMi82ZEZXMG9iTlZyMHR5aXBTM21vYklpSnZsUzdsRW0rSDRKSERpOFNwSXJMK0JweG1vOGd1d09lS1hRYzJSeHAva2Y1ejJ5L3hQbzNmWVhlQnNMMFp5V0c4NFkzeTVPT1JIcndUcGZlM082WmlhaTlraVp5MVVIb01TVG1EM1RKek04c1BUVlFNMEVveWtSUk5YLzNENXFkNGhWTWg2VG9oKzRFdG40NkdaTVhPZzFrUmtIVTZKNTBWbko4VVB1VTJtMCswaXpJdTlBSnBRSlJuSW9yRFNHSmJqRTU0eE9hR2xqbXZlZU8yemFjM0R4MUMvY2RlaVZZUDhrM2ZPOTVmb3Bna0FPbVpEK05DOHNTbHIrU3QrZy96VE01VmlSWjAydGxBL3Q4Y3VDY1VIdXBLNUxKRzl5RVllZEVnaFNOWXVFTVBsOThpOHV2Mm1hZEZzK3RuVGR1dTZaIiwiaWF0IjoxNzA5MjE5ODMzfQ.UGX0SGS1WpAvuapYAU3XpymT-1f94OqvjkLJgjkOiUE");
    const decodedHeader = jwtDecode(localStorage.getItem("userToken"));

    const decryptData = (encryptedData) => {
        var C = CryptoJS;
        var Key = C.enc.Utf8.parse("oSOhgvKFi2AbgyVwtKMKwFV8pSc5kyxU");
        var IV = C.enc.Utf8.parse("oSOhgvKFi2AbgyVw");
        var decryptedText = C.AES.decrypt(encryptedData, Key, {
            iv: IV,
            mode: C.mode.CBC,
            padding: C.pad.Pkcs7
        });
        return decryptedText.toString(CryptoJS.enc.Utf8);
    }
    var userData = JSON.parse(decryptData(decodedHeader?.key)) ? JSON.parse(decryptData(decodedHeader?.key)) : "";

    return userData;
}

export default getLoggedInUser;